import React from "react";
import { Icons } from "../../../../icons";
import { ClearButton as StyledClearButton } from "../Select.styles";

interface ClearButtonProps {
  onClear: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

export const ClearButton: React.FC<ClearButtonProps> = ({
  onClear,
  disabled = false,
}) => {
  return (
    <StyledClearButton
      type="button"
      onClick={onClear}
      disabled={disabled}
      aria-label="Limpiar selección"
    >
      <Icons name="iconClose" width={16} height={16} color="currentColor" />
    </StyledClearButton>
  );
};
